import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { getCenterStyles, getFlexStyles } from "vig-ui-library";

export type AppAlertProps = {
    headline: React.ReactNode;
    description: React.ReactNode;
};

export const AppAlert = ({ headline, description }: AppAlertProps) => {
    const theme = useTheme();

    return (
        <Box sx={{ ...getFlexStyles("column"), width: "100%", minWidth: 0, maxWidth: "100%" }}>
            <svg
                width="136"
                height="21"
                viewBox="0 0 136 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ maxWidth: "100%", height: "auto" }}
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 21H19.2825L35.0469 0C35.0469 0 40.903 5.07949 45.4255 7.71664C61.0758 16.8428 80.0891 21 96.205 21C127.364 21 136 21 136 21"
                    fill={theme.palette.primary.light}
                />
            </svg>
            <Box
                sx={{
                    ...getCenterStyles("column"),
                    padding: 2,
                    gap: 0.5,
                    width: "100%",
                    borderRadius: "7px",
                    backgroundColor: theme.palette.primary.light,
                }}
            >
                <Typography variant="h6" component="h2" textAlign="center">
                    {headline}
                </Typography>
                <Typography variant="body2" textAlign="center" sx={{ overflowWrap: "anywhere" }}>
                    {description}
                </Typography>
            </Box>
        </Box>
    );
};
